import { Command } from "commander";
import { commandComposeCreativeDraft } from "../usecases/script/compose-creative-draft.js";
import { commandExportAuthoring, type AuthoringExportKind } from "../usecases/script/export-authoring.js";
import { commandWriteAuthoring } from "../usecases/script/write-authoring.js";
import { describeArguments, dispatch, type RunState, withScriptOpts } from "./registry.js";

/** Structured transactions for application compilers; prose editing uses read/write. */
export function registerAuthoringCommands(program: Command, state: RunState): void {
  const authoring = program.command("authoring")
    .description("Structured screenplay compilation and atomic application transactions");
  const write = withScriptOpts(authoring.command("write <file>"))
    .description("Plan or apply a complete structured authoring document")
    .option("--create", "Create the selected target")
    .option("--replace", "Replace the selected target")
    .option("--apply", "Apply the exact plan")
    .option("--plan <digest>", "Exact plan digest to apply")
    .action(dispatch(commandWriteAuthoring, state));
  describeArguments(write, ["Structured .scriptctl file"]);
  const compose = withScriptOpts(authoring.command("compose <file>"))
    .description("Compile a readable scene JSON draft with generated identities and timing")
    .option("--apply", "Apply the exact plan")
    .option("--plan <digest>", "Exact plan digest to apply")
    .action(dispatch(commandComposeCreativeDraft, state));
  describeArguments(compose, ["Readable scene JSON file"]);
  const exportCommand = authoring.command("export")
    .description("Export complete structured content, including identities and extensions");
  const kinds: AuthoringExportKind[] = ["script", "episodes", "episode-spans", "scenes", "scene-spans", "action-spans"];
  for (const kind of kinds) {
    const command = withScriptOpts(exportCommand.command(kind), "read")
      .description(`Export structured ${kind}`)
      .requiredOption("-o, --output <file>", "Destination .scriptctl file");
    if (kind !== "script") command.requiredOption("-i, --in <selector>", "Formal ID or @ep:N selector / inclusive range");
    command.action(dispatch((opts) => commandExportAuthoring(kind, opts), state));
  }
}
